/* unplugin-vue-components disabled */import { render } from "./likeunlike.vue?vue&type=template&id=31e7000a&scoped=true"
import script from "./likeunlike.vue?vue&type=script&lang=js"
export * from "./likeunlike.vue?vue&type=script&lang=js"

import "./likeunlike.vue?vue&type=style&index=0&id=31e7000a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e7000a"]])

export default __exports__